export const SIMULATION_SET_VIEW = 'SIMULATION_SET_VIEW';
export const SIMULATION_SET_SORT = 'SIMULATION_SET_SORT';
export const SIMULATION_SET_SLOT = 'SIMULATION_SET_SLOT';
export const SIMULATION_SET_GROUPING = 'SIMULATION_SET_GROUPING';
export const SIMULATION_SET_FILTER = 'SIMULATION_SET_FILTER';
export const SIMULATION_SET_TOP_COUNT = 'SIMULATION_SET_TOP_COUNT';

export const SIMULATION_LOAD_CONTENDERS = 'SIMULATION_LOAD_CONTENDERS';
export const SIMULATION_LOAD_CONTENDERS_SUCCESS =
  'SIMULATION_LOAD_CONTENDERS_SUCCESS';
export const SIMULATION_LOAD_CONTENDERS_FAILURE =
  'SIMULATION_LOAD_CONTENDERS_FAILURE';

export const SIMULATION_VIEW_SETUP = 'SIMULATION_VIEW_SETUP';
export const SIMULATION_VIEW_INPROGRESS = 'SIMULATION_VIEW_INPROGRESS';
export const SIMULATION_VIEW_FINISHED = 'SIMULATION_VIEW_FINISHED';

export const SIMULATION_GROUPING_MINE = 'SIMULATION_GROUPING_MINE';
export const SIMULATION_GROUPING_GROUP = 'SIMULATION_GROUPING_GROUP';
export const SIMULATION_GROUPING_SCHOOL = 'SIMULATION_GROUPING_SCHOOL';
export const SIMULATION_GROUPING_CLASSROOM = 'SIMULATION_GROUPING_CLASSROOM';
export const SIMULATION_GROUPING_DISTRICT = 'SIMULATION_GROUPING_DISTRICT';
export const SIMULATION_GROUPING_TOP = 'SIMULATION_GROUPING_TOP';

export const SIMULATION_FILTER_ALL = 'all';
export const SIMULATION_FILTER_STAGED = 'staged';
export const SIMULATION_FILTER_TESTED = 'tested';
export const SIMULATION_FILTER_INVALID = 'invalid';

export const SIMULATION_START = 'SIMULATION_START';
export const SIMULATION_START_SUCCESS = 'SIMULATION_START_SUCCESS';
export const SIMULATION_START_FAILURE = 'SIMULATION_START_FAILURE';
export const SIMULATION_FINISH = 'SIMULATION_FINISH';
export const SIMULATION_RESET = 'SIMULATION_RESET';
